import React from 'react';
import { Alert, Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';
import FalconCloseButton from 'components/common/FalconCloseButton';
import SelectorCompaniaTarjeta from './SelectorCompaniaTarjeta';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const ModalRegistrarPago = ({
    show,
    onHide,
    orden,
    dataForm,
    setDataForm,
    formaPago,
    bIsACredito,
    calcularInsoluto,
    onSubmit,
    procesandoModal
}) => {
    console.log("modal normal pago")
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title>Registrar Pago</Modal.Title>
                <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={onHide} />
            </Modal.Header>
            <Modal.Body>
                <Alert variant="warning" className="d-flex align-items-center fs--1 mb-3 py-2 border-warning">
                    <FontAwesomeIcon icon={faExclamationTriangle} className="text-warning fs-0 me-2 flex-shrink-0" />
                    <div>
                        <strong>Aviso:</strong> Al registrar este pago, la orden quedará marcada como pagada y será <strong>bloqueada para edición</strong>.
                    </div>
                </Alert>

                <Row>
                    <Col md={12} xl={12} xxl={12} className="text-center text-md-center text-xl-center text-xxl-center">
                        <div className="fs-2 fw-semi-bold">Saldo a Pagar:</div>
                        <div className="fs-4 fw-semi-bold">
                            <span className="text-danger">
                                ${parseFloat(orden.dSaldoInsoluto).toLocaleString("es-MX", {
                                    maximumFractionDigits: 2,
                                    minimumFractionDigits: 2
                                })}
                            </span> {orden.vMoneda}
                        </div>
                        <hr></hr>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>Monto del Pago</Form.Label>
                            <Form.Control
                                onChange={(e) => calcularInsoluto(orden.dSaldoInsoluto, e.target.value)}
                                type="number"
                                size="md"
                                required
                                disabled={!bIsACredito}
                                value={dataForm.dImportePagado}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>Saldo Insoluto</Form.Label>
                            <Form.Control
                                type="number"
                                size="md"
                                required
                                disabled
                                value={dataForm.dSaldoInsoluto}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Form.Group className="mb-3">
                    <Form.Label>Forma de pago</Form.Label>
                    <Form.Select
                        className="mb-3"
                        disabled={!bIsACredito}
                        value={dataForm.idCatFormaPago}
                        onChange={(e) => {
                            const valor = e.target.value;
                            setDataForm({
                                ...dataForm,
                                idCatFormaPago: valor,
                                vJsonDetallesLinkPago: {
                                    ...dataForm.vJsonDetallesLinkPago,
                                    vCardType: valor === "4" ? 'credit' : valor === "18" ? 'debit' : ''
                                }
                            });
                        }}
                    >
                        <option value="">Selecciona forma de pago</option>
                        {formaPago.map((fp, index) => (
                            <option key={index} value={fp.idCatFormaPago}>{fp.vDescripcionFormaPago}</option>
                        ))}
                    </Form.Select>
                </Form.Group>

                {(parseInt(dataForm.idCatFormaPago) === 4 || parseInt(dataForm.idCatFormaPago) === 18) && (
                    <SelectorCompaniaTarjeta
                        value={dataForm.vJsonDetallesLinkPago?.vCardCompany || ""}
                        onChange={(value) => {
                            setDataForm({
                                ...dataForm,
                                vJsonDetallesLinkPago: {
                                    ...dataForm.vJsonDetallesLinkPago,
                                    vCardCompany: value,
                                    vCardType: dataForm.vJsonDetallesLinkPago?.vCardType || (parseInt(dataForm.idCatFormaPago) === 4 ? 'credit' : 'debit')
                                }
                            });
                        }}
                    />
                )}

                <Form.Group className="mb-3">
                    <Form.Label>Fecha del Pago</Form.Label>
                    <Form.Control
                        onChange={(e) => setDataForm({ ...dataForm, dFechaPago: e.target.value })}
                        className="mb-3"
                        type="date"
                        size="md"
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Folio / Rastreo</Form.Label>
                    <Form.Control
                        onChange={(e) => setDataForm({ ...dataForm, vReferencia: e.target.value })}
                        type="text"
                        size="md"
                        required
                        value={dataForm.vReferencia}
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Comprobante de pago</Form.Label>
                    <Form.Control
                        type="file"
                        size="sm"
                        required
                        onChange={(e) => setDataForm({
                            ...dataForm,
                            vArchivo: e.target.files[0],
                            vNombreDocumento: e.target.files[0].name,
                            vTipoDocumento: e.target.files[0].type,
                            vTamano: e.target.files[0].size,
                        })}
                    />
                </Form.Group>
            </Modal.Body>

            <Modal.Footer>
                <Button onClick={onHide} variant='primary' disabled={procesandoModal}>Cerrar</Button>
                {procesandoModal ? (
                    <Button variant="success" disabled>
                        <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                        &nbsp;Procesando...
                    </Button>
                ) : (
                    <Button type="button" onClick={onSubmit} variant='success'>REGISTRAR PAGO</Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

ModalRegistrarPago.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    orden: PropTypes.object.isRequired,
    dataForm: PropTypes.object.isRequired,
    setDataForm: PropTypes.func.isRequired,
    formaPago: PropTypes.array.isRequired,
    bIsACredito: PropTypes.bool.isRequired,
    calcularInsoluto: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    procesandoModal: PropTypes.bool.isRequired
};

export default ModalRegistrarPago;
